import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { joinEntryTarget } from '../lib/joinFlow';

// JoinPage completes authentication and loads team context before showing success.
// Opening this entry must never mark an unapproved legacy request as completed.
export default function Onboarding() {
  const location = useLocation();
  return <Navigate to={joinEntryTarget(location.search)} replace />;
}
